//interface for columns
export interface ColumnMeta {
  field: string;
  header: string;
}

// user list column
export const UserListColumns: ColumnMeta[] = [
  { field: 'unique_id', header: 'User Id' },
  { field: 'name', header: 'Name' },
  { field: 'email', header: 'Email' },
  { field: 'phone', header: 'Phone' },
  { field: 'address', header: 'Adreess' },
  { field: 'action', header: 'Action' },
];

// Employee list column
export const EmployeeListColumns: ColumnMeta[] = [
  { field: 'unique_id', header: 'Employee Id' },
  { field: 'name', header: 'Name' },
  { field: 'email', header: 'Email' },
  { field: 'mobile_no', header: 'Phone ' },
  { field: 'joining_date', header: 'Joining Date' },
  { field: 'status', header: 'Status' },
  // { field: "address", header: "Adreess" },
  { field: 'action', header: 'Action' },
];

// tax list column
export const TaxListColumns: ColumnMeta[] = [
  { field: 'name', header: 'Name' },
  { field: 'email', header: 'Email' },
  { field: 'phone', header: 'Phone ' },
  // { field: "date_of_birth", header: "Date of Birth" },
  // { field: "address", header: "Adreess" },
  // { field: 'booked_date', header: 'Tax Filing Dates' },
  {
    field: 'first_time_form_filling_status',
    header: 'First Time',
  },
  { field: 'tax_form_status', header: 'Form Status' },
  { field: 'balance_payment', header: 'Balance $' },
  { field: 'tax_filled_by', header: 'Tax File Processed By' },
  { field: 'note', header: 'Notes' },
  // { field: "slot_booking_status", header: "Booking Status" },
  { field: 'upload_doc', header: 'Upload Doc' },
  // { field: 'upload_spouse_doc', header: 'Upload Spouse Doc' },
  { field: 'signed_doc', header: 'Signed Doc' },
  { field: 'email_note', header: 'Document Request' },
  { field: 'gst_data', header: 'GST Calc' },
  { field: 'action', header: 'Action' },
  // { field: "signed_url", header: "Signed Pdf" },
];

//manually added tax payer list column
export const ManualTaxListColumns: ColumnMeta[] = [
  { field: 'first_name', header: 'First Name' },
  { field: 'last_name', header: 'Last Name' },
  { field: 'email', header: 'Email' },
  { field: 'mobile', header: 'Phone ' },
  { field: 'dec_marraige_status', header: 'Marriage Status' },
  { field: 'spouse_details', header: 'Spouse Details' },
];

// tax-list detail of user
export const TaxListDetailColumns: ColumnMeta[] = [
  { field: 'type', header: 'File Name' },
  { field: 'file_url', header: 'File' },
  { field: 'review_status', header: 'Doc Status' },
  { field: 'upload_doc', header: 'Upload Doc' },
];

// PayRoll List Column
export const EmployeePaystubListColumns: ColumnMeta[] = [
  { field: 'createdAt', header: 'Date' },
  { field: 'pay_period', header: 'Pay Period' },
  { field: 'hour', header: 'Working Hours' },
  { field: 'paystub_url', header: 'Paystub' },
];

// holidays list column
export const HolidayListColumns: ColumnMeta[] = [
  { field: 'date', header: 'Date' },
  { field: 'name', header: 'Holiday Name' },
  { field: 'action', header: 'Action' },
];

// doc to be signed list column
export const DocToBeSignedColumns: ColumnMeta[] = [
  { field: 'file_url', header: 'Uploaded Document' },
  { field: 'signed_url', header: 'Signed Document' },
];

// tax payer payment done list column
export const TaxPayerPaymentDoneColumns: ColumnMeta[] = [
  { field: 'createdAt', header: 'Payment Date' },
  { field: 'amount', header: 'Amount' },
];

// company list column
export const CompanyListColumns: ColumnMeta[] = [
  { field: 'company_name', header: 'Company Name' },
  { field: 'business_no', header: 'Business Number' },
  { field: 'email', header: 'Email' },
  { field: 'mobile_no', header: 'Mobile Number' },
  { field: 'document_status', header: 'Documents' },
  { field: 'financials', header: 'Financials' },
  { field: 'tax_filing', header: 'Tax Filing' },
  { field: 'gst_filing', header: 'GST Filing' },
  { field: 'wcb_filing', header: 'WCB Filing' },
  { field: 't4a_return', header: 'T4A Return' },
  { field: 't5_return', header: 'T5 Return' },
  { field: 'action', header: 'Action' }
];

// company tax filing list column
export const TaxFilingColumns: ColumnMeta[] = [
  { field: 'year', header: 'Year' },
  { field: 'date', header: 'Due Date' },
  // { field: 'amount', header: 'Amount' },
  { field: 'document_status', header: 'Documents' },
  { field: 'bank_rec', header: 'Bank Rec' },
  { field: 'credit_card', header: 'Credit Card' },
  { field: 'financials', header: 'Financials' },
  { field: 't2_return', header: 'T2 Return' },
  { field: 't183_doc', header: 'T183 Doc' },
  { field: 't5_return', header: 'T5 Return' },
  { field: 't4a_return', header: 'T4A Return' },
  { field: 'payment', header: 'Payment' },
  { field: 'note', header: 'Notes' },
];

// company gst filing list column
export const GstFilingColumns: ColumnMeta[] = [
  { field: 'year', header: 'Year' },
  { field: 'date', header: 'Due Date' },
  { field: 'status', header: 'Status' },
];

// company wcb filing list column
export const WcbFilingColumns: ColumnMeta[] = [
  { field: 'year', header: 'Year' },
  { field: 'date', header: 'Due Date' },
  { field: 'status', header: 'Status' },
];

// uber calc list column
export const UberCalcListColumns: ColumnMeta[] = [
  { field: 'name', header: 'Name' },
  { field: 'sin_number', header: 'SIN No.' },
  { field: 'mobile_no', header: 'Mobile No.' },
  { field: 'taxable_income_line_101', header: '101' },
  { field: 'non_taxable_line_102', header: '102' },
  { field: 'gst_collected', header: '103' },
  { field: 'gst_itc', header: '106' },
  { field: 'total_net_after_fees', header: 'Total Income' },
  { field: 'status', header: 'Status' },
  { field: 'action', header: 'Action' },
];
